import React, { Component } from "react";
import {
  Navbar,
  Form,
  Nav,
  FormControl,
  NavDropdown,
  Dropdown,
} from "react-bootstrap";
import "../../stylesheets/header.css";
import logo from "../../images/iscore.png";
import { useTranslation } from "react-i18next";
import { useLanguageContext } from "../contexts/LanguageContext";
import { LogOut } from "../../global-state/actions/authAction";
import { connect } from "react-redux";
import axios from "axios";
import ErrorHandler from "../../error-handler/ErrorHandler";
import { bindActionCreators } from "redux";
import DropDownMenu from "./DropDownMenu";
import { useHistory } from "react-router";
import {
  Translate as LanguageIcon,
  Gear as SettingsIcon,
} from "react-bootstrap-icons";
function LanguageItem({ language, code }) {
  const { t, i18n } = useTranslation();
  const { setLanguage } = useLanguageContext();
  return (
    <NavDropdown.Item
      onClick={() => {
        setLanguage(code);
        localStorage.setItem("lang", code);
      }}
    >
      {language}
    </NavDropdown.Item>
  );
}

function LanguageSelector() {
  const { t, i18n } = useTranslation();

  return (
    <NavDropdown className="adminDrop disbleSelection" title={t("currentLang")}>
      <LanguageItem language={t("ar")} code={"ar"} />
      <LanguageItem language={t("en")} code={"en"} />
    </NavDropdown>
  );
}

function Header(props) {
  const history = useHistory();
  const logout = (e) => {
    props.LogOut(history);
    history.push("/")
  };
  const { t, i18n } = useTranslation();

  return (
    <div>
      <Navbar fixed="top" className="myNav" bg="light">
        <Navbar.Brand href="/">
          <img
            className="img-fluid logo disbleSelection"
            src={logo}
            alt="logo"
          />
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="basic-navbar-nav" />

        <Navbar.Collapse id="basic-navbar-nav">
          <Nav style={{ paddingLeft: "5%" }} className="mr-auto"></Nav>
        </Navbar.Collapse>
        <div className="dropdown-item-list">
          <i>
            <LanguageIcon />
          </i>
          <div>
            <NavDropdown
              className="adminDrop disbleSelection innerDropdown"
              title={t("currentLang")}
            >
              <LanguageItem language={t("ar")} code={"ar"} />
              <LanguageItem language={t("en")} code={"en"} />
            </NavDropdown>
          </div>
        </div>
        <DropDownMenu logout={logout} />
      </Navbar>
    </div>
  );
}

const mapStateToProps = (state) => ({
  user: state.auth.user,
});
const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({ LogOut }, dispatch);
};
export default connect(mapStateToProps, mapDispatchToProps)(Header);
